// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"PartnerSetupInformation-messageBox-1ZN1za"};